import React, { useState, useEffect } from 'react';

import {
  getConditions,
  postCondition,
  editCondition,
  deleteCondition,
} from '../../../api/services/conditionsApi';

import ContentChangeButton from '../../../components/admin/buttons/ContentChangeButton/ContentChangeButton';
import AdminConditionCard from '../../../components/admin/cards/AdminConditionCard/AdminConditionCard';
import ConditionModal from '../../../components/admin/modals/ConditionModal/ConditionModal';
import ConfirmDeleteModal from '../../../components/admin/modals/ConfirmDeleteModal/ConfirmDeleteModal';

import './AdminConditions.css';

const AdminConditions = () => {
  const [conditions, setConditions] = useState([]);
  const [selectedCondition, setSelectedCondition] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [editModalMode, setEditModalMode] = useState('edit');

  //Condition Admin Page
  const getAllConditions = async () => {
    try {
      const allConditions = await getConditions();
      setConditions(allConditions);
    } catch (err) {
      console.error('Failed to fetch conditions:', err);
    }
  };

  useEffect(() => {
    getAllConditions();
  }, []);

  const onAddClickHandler = () => {
    setSelectedCondition({});
    setEditModalMode('add');
    setIsEditModalOpen(true);

    setIsDeleteModalOpen(false);
  };

  const onEditClickHandler = (condition) => {
    setSelectedCondition(condition);
    setEditModalMode('edit');
    setIsEditModalOpen(true);

    setIsDeleteModalOpen(false);
  };

  const onDeleteClickHandler = (condition) => {
    setSelectedCondition(condition);
    setIsDeleteModalOpen(true);

    setIsEditModalOpen(false);
  };

  const onModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedCondition(null);
  };

  const onDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
    setSelectedCondition(null);
  };

  const handleSubmit = async (formData) => {
    try {
      if (editModalMode === 'edit') {
        await editCondition(selectedCondition._id, formData);
        alert('Success! Condition updated successfully!');
      } else {
        await postCondition(formData);
        alert('Success! Condition created successfully!');
      }

      await getAllConditions();
      onModalClose();
    } catch (error) {
      console.error('Submit failed:', error);
    }
  };

  const onConfirmDelete = async () => {
    try {
      await deleteCondition(selectedCondition._id);
      await getAllConditions();
      onDeleteModalClose();

      alert(`Deleted! ${selectedCondition.name} deleted successfully!`);
    } catch (error) {
      console.error('Delete failed:', error);
      alert('Failed to delete condition.');
    }
  };

  return (
    <div className='condition__page'>
      <div className='admin-condition-container'>
        <div className='admin__condition__title'>
          <div id='condition-list-title'>Conditions</div>
          <div>
            <ContentChangeButton
              iconType='add'
              size='large'
              width='long'
              onClickHandler={onAddClickHandler}
            >
              Add Condition
            </ContentChangeButton>
          </div>
        </div>
        <div className='condition-grid-container'>
          {conditions.map((c) => (
            <AdminConditionCard
              key={c._id}
              condition={c}
              onEditClickHandler={onEditClickHandler}
              onDeleteClickHandler={onDeleteClickHandler}
            />
          ))}
        </div>
      </div>
      {isEditModalOpen && (
        <ConditionModal
          onClose={onModalClose}
          onSubmit={handleSubmit}
          condition={selectedCondition}
          mode={editModalMode}
        />
      )}
      {isDeleteModalOpen && (
        <ConfirmDeleteModal
          onClose={onDeleteModalClose}
          onConfirm={onConfirmDelete}
          deleteItemTitle={selectedCondition?.name}
        />
      )}
    </div>
  );
};

export default AdminConditions;
